import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { statements } from "@/mocks/statements";

export default function CategorySection() {
  return (
    <section aria-labelledby="home-categories" className="mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
      <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div>
          <h2 id="home-categories" className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            按类别查找官方口径
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            公告库按性质分为四类，先确定你要找的是正式立场、辟谣澄清，还是服务性通知。
          </p>
        </div>
        <Link
          to="/statements"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-600 cursor-pointer"
        >
          进入公告库
          <span className="flex h-4 w-4 items-center justify-center"><i className="ri-arrow-right-line" /></span>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((cat) => {
          const count = statements.filter((item) => item.categoryId === cat.id).length;
          return (
            <Link
              key={cat.id}
              to={`/statements?category=${cat.id}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/40 cursor-pointer"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-xl text-accent-800">
                <i className={cat.icon} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-700">
                {cat.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.description}</p>
              <span className="mt-4 text-xs text-foreground-500">本类已收录 {count} 篇</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}